class LStorage {
    constructor() {
    }

    setItem(a,b) {
        if (window.isNFT) {
            return;
        }
        return window.localStorage.setItem(a,b);
        
    }

    removeItem(a) {
        if (window.isNFT) {
            return;
        }
        window.localStorage.removeItem(a);
    }

    getItem(a) {
        if (window.isNFT) {
            return null;
        }
        return window.localStorage.getItem(a);
    }
}

export const lstorage = new LStorage();
